<template>
  <div class="application-title">
    <div class="application-title__utils">
      <el-row>
        <el-col
          class="application-title-logo--wrapper"
          id="nipponia-web-application-title"
        >
          <!-- <el-image
            class="application-title-logo"
            :src="sitirLogo"
            fit="contain"
          ></el-image> -->
          <el-image
            v-if="envIcon"
            class="application-title-logo"
            :src="testEnvIcon"
            fit="contain"
          ></el-image>
        </el-col>
        <el-col class="application-title-org-outer">
          <div class="application-title-org">
            <div
              class="application-title-org__icon-wrapper"
              @click="toggleOrg"
              id="nipponia-web-current-org"
            >
              <el-image
                class="application-title-org__icon"
                :src="orgIcon"
                fit="contain"
                title="切换组织"
              ></el-image>
              <span class="application-title-org__icon-wrapper-title">
                {{ this.currentOrg.orgName }}
              </span>
            </div>
            <div
              class="application-title-button_icon-wrapper"
              id="nipponia-web-refresh"
            >
              <el-image
                class="application-title-button_icon"
                :src="refreshIcon"
                fit="contain"
                @click="systemRefresh"
                title="刷新系统"
              ></el-image>
            </div>
            <div class="application-title-path-wrapper" id="nipponia-web-path">
              <span
                v-for="(path, index) in this.titlePath.path"
                :key="index"
                :class="
                  index === titlePath.path.length - 1
                    ? 'application-title-path-headLabel-active'
                    : 'application-title-path-headLabel'
                "
              >
                {{ path }}
                <span
                  v-if="index < titlePath.path.length - 1"
                  class="application-title-path-headLabel-split"
                  >/</span
                >
              </span>
            </div>
          </div>
        </el-col>
        <el-col>
          <el-popover
            width="160"
            placement="top-end"
            v-model="appSetAvatarVisible"
          >
            <el-row class="application-title-setting" :gutter="6" type="flex">
              <!-- <el-col
                class="application-title-setting__about el-icon-edit-outline"
                @click.native="personCenter"
                >个人设置</el-col
              > -->
              <el-col
                class="application-title-setting__about el-icon-edit-outline"
                @click.native="editPwd"
                >修改密码</el-col
              >
              <el-col
                class="application-title-setting__about el-icon-switch-button"
                @click.native="toLogin"
                >退出登录</el-col
              >
            </el-row>
            <img
              class="user-img"
              id="nipponia-web-user"
              slot="reference"
              src="../../../assets/img/photo.gif"
              alt="个人信息"
              title="个人信息"
            />
          </el-popover>
        </el-col>
        <el-col>
          <span>{{
            $store.state.keycloakToken.tokenParsed.family_name +
            $store.state.keycloakToken.tokenParsed.given_name
          }}</span>
        </el-col>
        <el-col class="application-title-button_icon-wrapper">
          <el-image
            class="application-title-button_icon"
            :src="worldIcon"
            alt="切换语言"
            title="切换语言"
          ></el-image>
        </el-col>
        <!-- <el-col>
          <img @click="toggleToHelpDesk" class="user-img1" id="nipponia-web-user" src="../../../assets/img/helpdesk.png" alt="服务台" title="服务台" />
        </el-col> -->
        <el-col>
          <!-- 点击打开系统设置选项 -->
          <el-popover width="160" v-model="appSetOptionsVisible">
            <el-row class="application-title-setting">
              <el-col
                v-if="isInElectronApp"
                class="application-title-setting__about el-icon-warning-outline"
                @click.native="handCheckUpdata"
                >自动更新</el-col
              >
              <el-col
                v-if="isInElectronApp"
                class="application-title-setting__about el-icon-warning-outline"
                @click.native="aboutsystem"
                >关于系统</el-col
              >
              <el-col
                v-if="isInElectronApp"
                class="application-title-setting__about el-icon-warning-outline"
                @click.native="toggleEnv"
                >环境切换</el-col
              >
              <el-col
                class="application-title-setting__about el-icon-warning-outline"
                @click.native="toggleRoute"
                >开发设置</el-col
              >
            </el-row>
            <div
              slot="reference"
              class="el-icon-more application-title-setting-more"
              id="nipponia-web-setting-more"
              title="更多设置"
            ></div>
          </el-popover>
        </el-col>
      </el-row>
    </div>
    <component
      :is="currentOpenCom"
      :printers="printers"
      :dialogVisible="dialogVisible"
      :rootOrg="rootOrg"
      :orgList="orgList"
      @updateDialogVisible="updateDialogVisible"
    ></component>
  </div>
</template>

<script>
import PersonCenter from 'component/system/PersonCenter'
import EditPwd from 'component/system/EditPwd'

import navPagePluginSelectOrg from './navPagePluginSelectOrg'

import { createMicroApp } from '@/config/microAppConfig.js'

import { mapState } from 'vuex'
import UrlParse from 'url-parse'

import showCurrentApp from '@/utils/showCurrentApp.js'

export default {
  name: 'application-title',
  props: ['heights'],
  data() {
    return {
      helpDeskUrl: '',
      rootOrg: {},
      orgList: [],
      sitirLogo: require('assets/img/logo.long.png'),
      testEnvIcon: require('assets/img/test-icon.png'),
      orgIcon: require('assets/img/icon/corporate-alt.png'),
      refreshIcon: require('assets/img/icon/laptop-refresh.png'),
      worldIcon: require('assets/img/icon/world_32.png'),
      currentOpenCom: '',
      printers: [],
      username: '',
      dialogVisible: false,
      height: '48px',
      isFullScreen: true,
      appSetOptionsVisible: false,
      appSetAvatarVisible: false,
      isInElectronApp: this.pcCommonData ? true : false,
      regularQuitFlag: false,
      myHeight: 'myHeight',
    }
  },
  watch: {
    heights(val) {
      if (val.includes('0')) {
        this.myHeight = 'myHeight0'
      } else {
        this.myHeight = 'myHeight'
      }
    },
  },
  created() {},
  components: {
    EditPwd,
    navPagePluginSelectOrg,
    PersonCenter,
  },
  computed: {
    ...mapState(['appsInOrg', 'currentOrg', 'pcCommonData', 'tabs']),
    envIcon() {
      const env = this.pcCommonData.platApp?.env
      if (env && typeof env === 'object' && env.type === 'test') {
        return true
      }
      return false
    },
    loginFlag() {
      return true
    },
    selfheights() {
      return this.heights
    },
    titlePath() {
      const activeTab = this.tabs.find((tab) => tab.active)
      const activeTabPath = (activeTab.titleParent || []).concat(
        activeTab.title
      )
      return {
        //org: [this.currentOrg.currentTopOrg, this.currentOrg.orgName],
        path: activeTabPath,
        pathCount: activeTabPath.length,
      }
    },
  },
  mounted() {},
  methods: {
    systemRefresh() {
      // 直接刷新，清空缓存（暂时解决方案）
      location.reload()
    },
    openLink(page) {
      console.log(page, '测试jade')
      createMicroApp({
        ...page,
        pageUrl: page.pageUrl,
      }).then(async (res) => {
        await this.$tabs.openTab({
          // TODO：非body里面（即导航目录里面）的内容，加上这个标志，不然报错
          isElectronSideApp: true,
          title: page.pageTitle,
          titleParent: [],
          path: page.pageUrl,
          query: {},
        })
        this.$nextTick(() => {
          showCurrentApp()
        })
      })
    },
    toggleToHelpDesk() {
      const helpDeskUrl = this.getHelpDeskUrl()
      if (!helpDeskUrl) {
        parent.postMessage(
          {
            flag: 'notification',
            data: {
              type: 'error',
              title: '提示',
              duration: 3000,
              message: '请联系管理员配置helpDesk地址！',
            },
          },
          '*'
        )
        return true
      }
      this.openLink({
        applicationName: 'electron-external-app',
        pageKey: 'tools_1999',
        pageName: '帮助中心',
        status: 1,
        pageUrl: helpDeskUrl,
        pageTitle: '帮助中心',
      })
    },
    getHelpDeskUrl() {
      const currentEnvName = this.pcCommonData?.platApp?.name
      let currentEnv = this.pcCommonData?.remoteEnvData?.ingress
      if (!currentEnvName || !currentEnv) {
        return false
      }
      currentEnv = (currentEnv || []).find((ingress) => {
        const helpDesk = ingress?.env?.helpdesk
        if (!helpDesk) {
          return false
        }
        return ingress?.name === currentEnvName
      })
      return currentEnv?.env?.helpdesk || ''
    },
    async toggleOrg() {
      this.currentOpenCom = 'navPagePluginSelectOrg'
      this.dialogVisible = true
    },
    toggleRoute() {
      const page = {
        pageTitle: '开发设置',
        pageUrl: '/dev-custom-nav',
      }
      createMicroApp({
        ...page,
        pageUrl: page.pageUrl,
      }).then(async (res) => {
        await this.$tabs.openTab({
          title: page.pageTitle,
          path: page.pageUrl,
          query: {},
        })
        this.$nextTick(() => {
          showCurrentApp()
        })
        // actions.setGlobalState({ d: Date.now() })
      })
    },
    toggleEnv() {
      parent.postMessage(
        {
          handle: '切换环境',
        },
        '*'
      )
    },
    handCheckUpdata() {
      parent.postMessage(
        {
          handle: '客户端更新',
          data: {
            visible: true,
            flag: 'handle',
          },
        },
        '*'
      )
    },
    personCenter() {
      this.currentOpenCom = 'PersonCenter'
      this.dialogVisible = true
    },
    editPwd() {
      this.currentOpenCom = 'EditPwd'
      this.dialogVisible = true
    },
    aboutsystem() {
      parent.postMessage(
        {
          handle: '系统公共设置',
        },
        '*'
      )
    },
    aaa() {
      const authInfo = JSON.parse(localStorage.getItem('authInfo')).accountInfo
      this.username = authInfo ? authInfo.username.split('@')[0] : ''
    },
    // 弹框
    updateDialogVisible() {
      this.dialogVisible = false
      this.currentOpenCom = ''
    },
    async toLogin() {
      this.$fre.logout()
    },
  },
}
</script>

<style lang="scss">
.myHeight {
  height: 64px;
}
.myHeight0 {
  height: 0;
}
.application-title {
  height: 64px;
  width: 100%;
  display: block;
  -webkit-app-region: drag;
  background-repeat: no-repeat;
  background-size: contain;
  background: linear-gradient(90deg, #1d42ab 0%, #2173ac 50%, #3bb2ff 100%);
  box-shadow: 0 1px 4px 0 #1a1f451a;
  .el-button {
    -webkit-app-region: no-drag;
  }
  &-setting {
    flex-flow: column;
    .el-icon-edit-outline:before,
    .el-icon-switch-button:before {
      padding-left: 6px;
    }
    &__current {
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
      padding-left: 10px !important;
      font-weight: 600;
      font-family: 宋体;
      margin-bottom: 6px;
      color: #2f2f2f;
    }
    &__about {
      cursor: pointer;
      padding-top: 6px;
      padding-bottom: 6px;
      border-radius: 6px;
      & + & {
        margin-top: 6px;
      }
    }
    &-more {
      &:hover {
        &::before {
          color: #8d8d8d;
        }
      }
      &::before {
        transform: rotate(90deg);
        display: inline-block;
        margin-right: 12px;
      }
    }
  }
  &-logo {
    //width: 40px;
    height: 40px;
    margin-right: 10px;
    & + & {
      margin-left: 10px;
    }
    &--wrapper {
      margin: 0 0px;
    }
  }
  &-org__icon {
    filter: brightness(0) invert(1);
    height: 24px;
    margin-top: 8px;
    cursor: pointer;
    &-wrapper {
      //width: 36px;
      height: 64px;
      align-items: center;
      display: flex;
      flex-direction: column;
      transition: background-color 0.3s ease;
      padding: 0 6px;
      &:hover {
        background-color: rgba(255, 255, 255, 0.2);
      }
      &-title {
        font-weight: 700;
        color: #ffffff;
        font-size: 14px;
        text-shadow: 0 0 4px rgba(255, 255, 255, 0.3);
        cursor: pointer;
      }
    }
  }
  &-button_icon {
    filter: brightness(0) invert(1);
    height: 24px;
    margin-top: 18px;
    cursor: pointer;
    & + & {
      margin-left: 10px;
    }
    &-wrapper {
      //width: 36px;
      height: 64px;
      //display: flex;
      transition: background-color 0.3s ease;
      margin-left: 18px;
      padding: 0 6px;
      &:hover {
        background-color: rgba(255, 255, 255, 0.2);
      }
      &-title {
        font-weight: 700;
        color: #ffffff;
        font-size: 14px;
        margin-top: 32px;
        margin-right: 6px;
        text-shadow: 0 0 4px rgba(255, 255, 255, 0.3);
      }
    }
  }

  &-org {
    &-outer {
      flex: 1;
    }
    display: flex;
    font-size: 12px;
    color: #333;
    font-weight: 500;
    &--selectOrg.el-button {
      font-weight: 500;
      font-size: 12px;
      background: #477dff;
      color: #fff;
      width: 90px;
      height: 26px;
      padding: 0;
      margin-left: 15px;
      &::before {
        content: '\e6d2';
        transform: rotate(90deg);
        display: inline-block;
        margin-right: 6px;
      }
    }
  }
  &-path-wrapper {
    height: 64px;
    display: flex;
    align-items: center;
    margin-left: 18px;
    .el-icon {
      margin-right: 6px;
    }
  }
  &-path-headLabel {
    font-weight: 500;
    color: #ffffffb2;
    font-size: 14px;
    margin-right: 6px;
    &-split {
      margin-left: 8px;
      color: #ffffffb2;
    }
    &-active {
      font-weight: 700;
      color: #ffffff;
      font-size: 14px;
      margin-right: 6px;
      text-shadow: 0 0 4px rgba(255, 255, 255, 0.3);
    }
  }

  &__utils {
    height: 100%;
    *[class^='el-icon'],
    .iconfont {
      font-size: 18px;
      cursor: pointer;
      color: #d4d4d4;
    }
    .user-img {
      cursor: pointer;
      width: 36px;
      height: 36px;
      border-radius: 50%;
      margin-right: 10px;
    }
    .user-img1 {
      cursor: pointer;
      width: 40px;
      height: 40px;
      border-radius: 50%;
    }
    .el-row {
      height: 100%;
      width: 100%;
      display: flex;
      flex-flow: row nowrap;
      /* justify-content: center; */
      align-items: center;
    }
    .el-col {
      -webkit-app-region: no-drag;
      width: fit-content;
      color: #fff;
      &:hover {
        //cursor: pointer;
        color: rgba(255, 255, 255, 0.8);
      }
    }
  }
}
</style>
